// extracted by mini-css-extract-plugin
module.exports = {"gridCard":"src-components-UI-CardGrid-Card-styles-style-module__gridCard--Lhb34"};